"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const ProgressBar = ({ percent, status = 'normal', showInfo = true, className = '', barColorClassName, // added
 }) => {
    const clamped = Math.max(0, Math.min(100, percent));
    const getBarColor = () => {
        if (barColorClassName)
            return barColorClassName;
        switch (status) {
            case 'success':
                return 'bg-green-500';
            case 'exception':
                return 'bg-red-500';
            default:
                return 'bg-blue-500';
        }
    };
    const getStatusIcon = () => {
        if (status === 'success') {
            return react_1.default.createElement("span", { className: "demo-icon icon-check text-xs" });
        }
        if (status === 'exception') {
            return react_1.default.createElement("span", { className: "demo-icon icon-close text-xs" });
        }
        return null;
    };
    return (react_1.default.createElement("div", { className: `w-full flex items-center space-x-2 ${className}` },
        react_1.default.createElement("div", { className: "flex-1 h-[6px] relative rounded bg-gray-200 overflow-hidden bar", role: "progressbar", "aria-valuenow": clamped, "aria-valuemin": 0, "aria-valuemax": 100 },
            react_1.default.createElement("div", { className: `h-full ${getBarColor()} transition-all duration-300 ${status === 'active' ? 'animate-pulse' : ''}`, style: { width: `${clamped}%` } })),
        showInfo && (react_1.default.createElement("div", { className: "text-[14px] font-bold text-black text-right percentage", title: `${clamped}%` }, getStatusIcon() || `${clamped}%`))));
};
exports.ProgressBar = ProgressBar;
